var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(-371 -1365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    "data-name": "Path 2667",
    d: "M26,0H0V26H26Z",
    transform: "translate(371 1365)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2669",
    "data-name": "Path 2669",
    d: "M14.74,9l-.346,9M9.606,18,9.26,9m9.968-3.21c.342.052.682.107,1.022.166m-1.022-.165L18.16,19.673a2.25,2.25,0,0,1-2.244,2.077H8.084A2.25,2.25,0,0,1,5.84,19.673L4.772,5.79m14.456,0q-1.731-.262-3.478-.4m-12,.562c.34-.059.68-.114,1.022-.165m0,0q1.731-.262,3.478-.4m7.5,0V4.477a2.177,2.177,0,0,0-2.09-2.2q-1.66-.053-3.32,0a2.178,2.178,0,0,0-2.09,2.2v.916m7.5,0a48.667,48.667,0,0,0-7.5,0",
    transform: "translate(371.75 1366.25)",
    fill: "rgba(0,0,0,0)",
    stroke: "#52555e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0fed0090857e25d4b406bd56cb53bee7.svg";
export { ForwardRef as ReactComponent };